import { client } from '../common/client';
import type { GetShippingPoliciesResponse } from './utils/types';

/**
 * API client for site configuration operations
 */
class SiteconfigAPIClient {
  /**
   * Fetch all shipping policies
   * @returns Promise with shipping policies data
   */
  public async getShippingPolicies(): Promise<GetShippingPoliciesResponse> {
    return await client.get('/shippingPolicies').then((res) => res.data);
  }
}

export const siteconfigAPIClient = new SiteconfigAPIClient();
